import { render, staticRenderFns } from "./Genre.vue?vue&type=template&id=df8d95d2"
import script from "./Genre.vue?vue&type=script&lang=js"
export * from "./Genre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports